/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswithplace2Inputs */

const en_statswithplace2 = /** @type {(inputs: Statswithplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a place`)
};

const de_statswithplace2 = /** @type {(inputs: Statswithplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Ort`)
};

/**
* | output |
* | --- |
* | "With a place" |
*
* @param {Statswithplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswithplace2 = /** @type {((inputs?: Statswithplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswithplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswithplace2(inputs)
	return de_statswithplace2(inputs)
});
export { statswithplace2 as "statsWithPlace" }